export default function CheckoutContext({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
